'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const Block = require('ipld-block');

const CID = require('cids');

const multihash = require('multihashes');

const multipartRequest = require('../lib/multipart-request');

const configure = require('../lib/configure');

const toUrlSearchParams = require('../lib/to-url-search-params');

const anySignal = require('any-signal');

const AbortController = require('abort-controller');

module.exports = configure(api => {
  async function put(data, options = {}) {
    if (Block.isBlock(data)) {
      const {
        name,
        length
      } = multihash.decode(data.cid.multihash);
      options = _objectSpread(_objectSpread({}, options), {}, {
        format: data.cid.codec,
        mhtype: name,
        mhlen: length,
        version: data.cid.version
      });
      data = data.data;
    } else if (options.cid) {
      const cid = new CID(options.cid);
      const {
        name,
        length
      } = multihash.decode(cid.multihash);
      options = _objectSpread(_objectSpread({}, options), {}, {
        format: cid.codec,
        mhtype: name,
        mhlen: length,
        version: cid.version
      });
      delete options.cid;
    } // allow aborting requests on body errors


    const controller = new AbortController();
    const signal = anySignal([controller.signal, options.signal]);
    let res;

    try {
      const response = await api.post('block/put', _objectSpread({
        timeout: options.timeout,
        signal: signal,
        searchParams: toUrlSearchParams(options)
      }, await multipartRequest(data, controller, options.headers)));
      res = await response.json();
    } catch (err) {
      // Retry with "protobuf"/"cbor" format for go-ipfs
      // TODO: remove when https://github.com/ipfs/go-cid/issues/75 resolved
      if (options.format === 'dag-pb') {
        return put(data, _objectSpread(_objectSpread({}, options), {}, {
          format: 'protobuf'
        }));
      } else if (options.format === 'dag-cbor') {
        return put(data, _objectSpread(_objectSpread({}, options), {}, {
          format: 'cbor'
        }));
      }

      throw err;
    }

    return new Block(data, new CID(res.Key));
  }

  return put;
});